import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';

import { useStickyButton } from './useStickyButton';
import { CompilationHeaderLayout } from '../../components/CompilationHeaderLayout';
import { HeaderLayoutDesktop, HeaderLayoutMobile } from '../../components/HeaderLayout';
import { PageTitle } from '../../components/PageTitle';
import { useFixedHeader } from '../../hooks/fixedHeader';
import { selectIsCompilation } from '../../selectors/compilation';
import { selectIsEmptyPromoIds } from '../../selectors/promos';
import { selectPageSeo } from '../../selectors/seo';
import { BackButtonContainer } from '../BackButton';
import { ChipsContainer } from '../Chips';
import { CounterContainer } from '../CounterContainer';
import { ListingsLinksContainer } from '../ListingsLinks';
import { PageDescriptionContainer } from '../PageDescriptionContainer';
import { PromoCategoryPlateContainer } from '../PromoCategoryPlateContainer';
import { SearchSuggestContainer } from '../SearchSuggestContainer';
import { SearchSuggestTagsContainer } from '../SearchSuggestTagsContainer';
import { SortingContainer } from '../SortingContainer';

export const HeaderContainer: React.FC = () => {
  const isCompilation = useSelector(selectIsCompilation);
  const { h1 } = useSelector(selectPageSeo);

  const isEmptyPromoIds = useSelector(selectIsEmptyPromoIds);
  const hasSearchResults = !isEmptyPromoIds;

  const mobileHeaderRef = React.useRef<HTMLDivElement>(null);
  const compilationHeaderRef = React.useRef<HTMLDivElement>(null);

  const isFixedHeaderShown = useFixedHeader({ ref: mobileHeaderRef });

  useStickyButton({ mobileHeaderRef, compilationHeaderRef });

  if (isCompilation) {
    return (
      <CompilationHeaderLayout
        ref={compilationHeaderRef}
        title={<PageTitle>{h1}</PageTitle>}
        description={<PageDescriptionContainer isCompilation={true} />}
      />
    );
  }

  return (
    <>
      <Responsive desktop tablet>
        <HeaderLayoutDesktop
          title={<PageTitle>{h1}</PageTitle>}
          description={<PageDescriptionContainer isCompilation={false} />}
          sorting={hasSearchResults && <SortingContainer />}
          searchInput={<SearchSuggestContainer />}
          counter={hasSearchResults && <CounterContainer />}
          chips={<ChipsContainer />}
          tags={<SearchSuggestTagsContainer />}
          plate={<PromoCategoryPlateContainer />}
          listingsLinks={<ListingsLinksContainer />}
        />
      </Responsive>
      <Responsive phone>
        <HeaderLayoutMobile
          ref={mobileHeaderRef}
          isFixedHeaderShown={isFixedHeaderShown}
          backButton={<BackButtonContainer />}
          title={h1}
          sorting={hasSearchResults && <SortingContainer />}
          searchInput={<SearchSuggestContainer isFixedHeaderShown={isFixedHeaderShown} />}
          chips={<ChipsContainer />}
          tags={<SearchSuggestTagsContainer />}
          plate={<PromoCategoryPlateContainer />}
        />
      </Responsive>
    </>
  );
};
